import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { setErrorTrackingFeature } from 'services/errorTracking'

/**
 * Stamp the GlitchTip `feature` tag from the current route on every navigation.
 *
 * Mounted once at the router root (AppRoutes) so it covers auth, onboarding, and
 * dashboard routes alike. The derived feature sticks as a global Sentry tag, so
 * every later capture (error boundary, axios 5xx interceptor, direct captures)
 * is grouped by feature in GlitchTip without touching individual call sites.
 */
export function useFeatureTracking(): void {
    const { pathname } = useLocation()

    useEffect(() => {
        setErrorTrackingFeature(pathname)
    }, [pathname])
}
